/**
 * React Query's `onlineManager` starts at a hardcoded `true` and only
 * listens for `online`/`offline` transitions, so a page loaded while
 * already offline believes it is online until the connection comes back.
 * This is the one place in `apps/app` that reads `navigator.onLine`.
 */
import { onlineManager } from "@tanstack/react-query";

export function seedOnlineStatus(): void {
  if (typeof navigator === "undefined") return;
  onlineManager.setOnline(navigator.onLine);
}
